import Super from './document-request';

export default class DocumentRequestPostSessionSummary extends Super {}
